import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import html2pdf from 'html2pdf.js';


@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {

  constructor() { }

  data = {
    "document": {
      "documentName": "ASKAPP_555881623067054170.pdf",
      "documentId": "BF701AA152",
      "documentHash": "c4dfcbbae9b108a073e89cb5fa6a48051de356c2b24bdc8a286d45c10979a158",
      "status": "Completed",
      "platform": "Leegality.com"
    },
    "stampDetails": {
      "state": "Maharashtra",
      "totalStampAmount": 1100.0,
      "serialNumbers": [
        "XY 724743",
        "BC 452388",
        "BC 452438"
      ]
    },
    "auditTrail": [
      {
        "srNo": 1,
        "name": "ASK INVESTMENT MANAGERS LTD",
        "email": "registerit@askgroup.in",
        "activity": "Invitation sent",
        "dateTimeIST": "2021-06-08T12:41:04",
        "ipAddress": "104.211.92.116"
      },
      {
        "srNo": 2,
        "name": "Sivalenka Venkata Sarathkumar",
        "email": "SARATHEGMP6@YAHOO.COM",
        "mobile": "9845034249",
        "activity": "Opened",
        "dateTimeIST": "2021-06-08T12:41:24",
        "ipAddress": "115.99.143.219",
        "system": {
          "os": "Mac OS X",
          "browser": "Chrome",
          "device": "Other"
        }
      },
      {
        "srNo": 3,
        "name": "Sivalenka Venkata Sarathkumar",
        "activity": "eSigned using Aadhaar",
        "dateTimeIST": "2021-06-08T12:54:04",
        "ipAddress": "115.99.143.219",
        "signature": {
          "transactionId": "57483c98-cf33-4377-baca-c64d1d7d4911",
          "authenticationType": "One Time Password",
          "certificate": {
            "name": "S V Sarath Kumar",
            "serialNo": "4237348439",
            "issuer": "NSDL e-Gov CA 2014-2",
            "organization": "NSDL e-Governance Infrastructure Limited",
            "validityStart": "2021-06-08T12:54:01",
            "validityEnd": "2021-06-08T13:24:00",
            "pincode": "560047",
            "state": "Karnataka",
            "yearOfBirth": 1959,
            "gender": "M"
          }
        },
        "location": {
          "latitude": 12.9658866,
          "longitude": 77.6145189,
          "address": "Victoria Layout, Bengaluru, Karnataka, India",
          "accuracyMeters": 20
        }
      },
      {
        "srNo": 4,
        "name": "ASK INVESTMENT MANAGERS LTD",
        "activity": "Invitation sent to Digital Onboarding Authoriser",
        "dateTimeIST": "2021-06-08T12:54:04"
      },
      {
        "srNo": 5,
        "name": "Digital Onboarding Authoriser",
        "email": "digital@askpms.in",
        "activity": "Opened",
        "dateTimeIST": "2021-06-08T12:55:18",
        "ipAddress": "45.250.250.6",
        "system": {
          "os": "Windows",
          "browser": "Chrome"
        }
      },
      {
        "srNo": 6,
        "name": "Digital Onboarding Authoriser",
        "activity": "Opened",
        "dateTimeIST": "2021-06-08T12:55:24",
        "ipAddress": "40.94.228.37"
      },
      {
        "srNo": 7,
        "name": "Vishal Harish Mehra",
        "email": "digital@askpms.in",
        "activity": "eSigned using DSC",
        "dateTimeIST": "2021-06-08T12:55:49",
        "ipAddress": "45.250.250.6",
        "certificate": {
          "name": "Vishal Harish Mehra",
          "serialNo": "20738224",
          "issuer": "e-Mudhra Sub CA for Class 3 Individual 2014",
          "organization": "eMudhra Consumer Services Limited",
          "validityStart": "2021-02-22T16:48:44",
          "validityEnd": "2024-02-22T16:48:44",
          "pincode": "400008",
          "state": "Maharashtra"
        }
      },
      {
        "srNo": 8,
        "name": "ASK INVESTMENT MANAGERS LTD",
        "activity": "Completed",
        "dateTimeIST": "2021-06-08T12:55:49"
      }
    ]
  }

  getAuditTrailData() {
    return of(this.data);
  }

  download(element: HTMLElement, fileName: string = 'document.pdf') {

    const options: any = {
      margin: 0.5,
      filename: fileName,
      image: {
        type: 'jpeg',
        quality: 1
      },
      html2canvas: {
        scale: 2
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait'
      }
    };

    html2pdf()
      .set(options)
      .from(element)
      .save();
  }
}
